import { Injectable, EventEmitter } from "@angular/core";
import { Subject, ReplaySubject } from "rxjs";
import * as printJS from "print-js";

declare global {
  interface Window {
    showSaveFilePicker: any;
  }
}

@Injectable({
  providedIn: "root",
})
export class PrintingService {
  print(base64: string) {
    printJS({
      printable: base64,
      type: "pdf",
      base64: true,
      documentTitle: "doesn't work",
    });
  }

  async printLab(blob: Blob, filename: string, filetype: string) {
    try {
      var choiceAccept: {};
      switch (filetype.substr(-3)) {
        case "pdf":
          choiceAccept = {
            "application/pdf": [".pdf"],
          };
          break;
        case "csv":
          choiceAccept = {
            "application/vnd.ms-excel": [".csv"],
          };
          break;
        default:
          break;
      }

      const handle = await window.showSaveFilePicker({
        suggestedName: filename,
        types: [
          {
            accept: choiceAccept,
          },
        ],
      });
      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();
      return handle;
    } catch (err) {
      console.error(err.name, err.message);
    }
  }
}
